import * as Business    from '../business';
import * as Helpers     from './helpers';
import { connect }      from 'react-redux';
import CalendarTime     from '../components/calendar_time';
import FetchFromServer  from '../components/fetch_from_server';
import Navbar           from '../components/navbar';
import React            from 'react';
import StandaloneButton from '../components/standalone_button';


export default connect(
  (state, { businessID, navigateTo }) => ({
    businessID,
    navigateTo,
    dataSources: Business.getDataSources(state, businessID),
    statuses:    Business.getDataSourcesReadStatus(state, businessID)
  }),
  (dispatch, { businessID }) => ({
    load: () => dispatch(Business.readDataSources(businessID))
  })
)(DataSourcesPage);


export function DataSourcesPage({ businessID, dataSources, navigateTo, statuses, load }) {
  return (
    <React.Fragment>
      <Navbar title="Data Sources"/>
      <FetchFromServer statuses={statuses} load={load}>
        {dataSources && (
          <DataSourcesContainer businessID={businessID} navigateTo={navigateTo} dataSources={dataSources}/>
        )}
      </FetchFromServer>
    </React.Fragment>
  );
}


function DataSourcesContainer({ businessID, navigateTo, dataSources }) {
  const implict                  = Helpers.implicit(dataSources);
  const configured               = Helpers.configured(dataSources);
  const configurable             = Helpers.configurable(dataSources);
  const configurableWithCustomer = configurable.filter(({ customers }) => customers > 0);
  const hasCustomers             = [ ...configured, ...configurableWithCustomer ];

  const isEmpty          = implict.length === 0 && configured.length === 0;
  const canAddDataSource = configurable.length > 0;

  return (
    <div className="list media-list block inset">
      <ul className="list-group">
        <li className="list-group-title">Last 30 Days</li>
        {isEmpty && <EmptyState/>}
        {implict.map(source => (<ImplicitDataSource key={source.name} {...source}/>))}
        {hasCustomers.map(source => (<ConfiguredDataSource key={source.name} handleOnClick={() => navigateTo(`/${businessID}/settings/data_sources/${source.name}`)} {...source}/>))}
      </ul>
      {canAddDataSource && <StandaloneButton onClick={() => navigateTo(`/${businessID}/settings/data_sources/new`)} label="Add Data Source"/>}
    </div>
  );
}


// Implicit data sources (added by user, Windows integration, etc)
// Only present if new/repeat customers added in last 30 days
function ImplicitDataSource({ displayName, customers, lastUploadAt }) {
  return (
    <li className="item-content item-inner">
      <div className="item-title-row">
        <div className="item-title">{displayName}</div>
      </div>
      <div className="item-subtitle">
        <DataSourceStats customers={customers} lastUploadAt={lastUploadAt}/>
      </div>
    </li>
  );
}


// Configured data sources (online mostly)
// Present if configured, even if no customer added
function ConfiguredDataSource({ handleOnClick, displayName, customers, status, lastUploadAt }) {
  return (
    <li>
      <a onClick={handleOnClick} className="item-content item-link item-inner">
        <div className="item-title-row">
          <div className="item-title__badge">{displayName} <ConnectionStatus status={status}/></div>
        </div>
        <div className="item-subtitle">
          <DataSourceStats customers={customers} lastUploadAt={lastUploadAt}/>
        </div>
      </a>
    </li>
  );
}


function DataSourceStats({ customers, lastUploadAt }) {
  if (!customers)
    return 'No customers';

  const count = (customers === 1) ? '1 customer' : `${customers} customers`;
  return (
    <span>{count}, last updated <CalendarTime time={lastUploadAt}/></span>
  );
}


function ConnectionStatus({ status }) {
  switch (status) {
    case 200:
      return (<span className="badge badge-success">Connected</span>);
    case 401:
    case null:
    case undefined:
      return (<span className="badge badge-neutral">Disconnected</span>);
    default:
      return (<span className="badge badge-error">Error</span>);
  }
}


function EmptyState() {
  return (
    <li className="item-content item-inner">
      <div className="item-subtitle">No Data Available</div>
    </li>
  );
}
